import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface UtilitiesProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const Utilities: React.FC<UtilitiesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [utilities, set_utilities] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Site Work']?.['Utilities'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Utilities': v } } })
    );
    const label = 'Utilities';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(utilities)}
                />
            ) : (
                <MoneyBox
                    id={'utilities'}
                    allowNegative={false}
                    value={utilities}
                    onChange={(value) => set_utilities(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
